// 异常分析
// 在组件内部进行了处理绑定的click函数只要不是箭头函数 this指向都是正确的
export const exAnalConfig = {
  leftIcon: [
    {
      id: 1,
      title: $t('integration.anomaly_analysis'),
      icon: 'el-icon-s-marketing',
      textVal: $t('integration.anomaly_analysis')
    }
  ],
  rightIcon: [
    {
      id: 1,
      title: $t('public.reflash'),
      icon: 'el-icon-refresh',
      click () {
        const config = this.$refs.ex.getConfig()
        this.getExAnal(config.ex)
      }
    },
    {
      id: 2,
      title: $t('public.setting'),
      icon: 'el-icon-setting',
      click: function () {
        this.isShow = true
      }
    },
    {
      id: 3,
      title: $t('public.btn_close'),
      icon: 'el-icon-circle-close',
      click () {
        this.$delete(this.echartArray, 'ex')
      }
    }
  ]
}
// 报警触发分析
export const alarmAnalConfig = {
  leftIcon: [
    {
      id: 1,
      title: $t('integration.alarm_trigger_analysis'),
      icon: 'iconfont icon-baojing',
      textVal: $t('integration.alarm_trigger_analysis')
    }
  ],
  rightIcon: [
    {
      id: 1,
      title: $t('public.reflash'),
      icon: 'el-icon-refresh',
      click () {
        const config = this.$refs.alarm.getConfig()
        this.getAlarmAnal(config.alarm)
      }
    },
    {
      id: 2,
      title: $t('public.setting'),
      icon: 'el-icon-setting',
      click: function () {
        this.alarmAnalShow = true
      }
    },
    {
      id: 3,
      title: $t('public.btn_close'),
      icon: 'el-icon-circle-close',
      click () {
        this.$delete(this.echartArray, 'alarm')
      }
    }
  ]
}

// 正常异常比例分析
export const proportionAnalConfig = {
  leftIcon: [
    {
      id: 1,
      title: $t('integration.normal_and_abnormal_proportion_analysis'),
      icon: 'el-icon-pie-chart',
      textVal: $t('integration.normal_and_abnormal_proportion_analysis')
    }
  ],
  rightIcon: [
    {
      id: 1,
      title: $t('public.reflash'),
      icon: 'el-icon-refresh',
      click () {
        const config = this.$refs.normalAbnormal.getConfig()
        this.getProportion(config.normalAbnormal)
      }
    },
    {
      id: 2,
      title: $t('public.setting'),
      icon: 'el-icon-setting',
      click: function () {
        this.proportionAnalShow = true
      }
    },
    {
      id: 3,
      title: $t('public.btn_close'),
      icon: 'el-icon-circle-close',
      click () {
        this.$delete(this.echartArray, 'normalAbnormal')
      }
    }
  ]
}

// 监测点状态配置
export const pointStatusConfig = {
  rightIcon: [
    {
      id: 1,
      title: $t('public.reflash'),
      icon: 'el-icon-refresh',
      click () {
        this.getPointStatus()
      }
    }
  ]
}

// 监测点类型配置
export const pointTypeConfig = {
  rightIcon: [
    {
      id: 1,
      title: $t('public.reflash'),
      icon: 'el-icon-refresh',
      click () {
        this.getPointType()
      }
    }
  ]
}
